import React from 'react';

import { cn } from '@/shared/utils/cn';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const LoadingIndicator = ({ className, ...props }: Props) => {
  return (
    <div
      {...props}
      className={cn('flex h-36 w-36 items-center justify-center', className)}
    >
      <svg className="h-full w-full animate-spin" viewBox="0 0 50 50">
        <defs>
          <linearGradient id="spinner-gradient">
            <stop offset="0%" stopColor="#820ADD" />
            <stop offset="100%" stopColor="#2370CA" />
          </linearGradient>
        </defs>
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
          strokeLinecap="round"
          stroke="url(#spinner-gradient)"
          strokeDasharray="120,180"
          strokeDashoffset="25"
        />
      </svg>
    </div>
  );
};

export const CenteredLoadingIndicator = () => {
  return (
    <LoadingIndicator className="absolute left-1/2 top-1/2 size-9 -translate-x-1/2 -translate-y-1/2" />
  );
};
